import { memo } from 'react';
import SimpleProductTileInformation from './SimpleProductTileInformation';

const ProductInformation = ({
    comment,
    vehicleComment,
}: {
    comment: string | undefined;
    vehicleComment: string | undefined;
}) => {
    if (!comment && !vehicleComment) {
        return <div />;
    }

    return (
        <SimpleProductTileInformation
            comment={comment}
            vehicleComment={vehicleComment}
        />
    );
};

export default memo(ProductInformation);
